import { Component } from '@angular/core';
import { GlobalUtilsService } from '../global-utils.service';

@Component({
  selector: 'app-contact-info',
  template: `
    <div
      class="contact-info-wrap"
      [ngClass]="{
        tablet: globalUtilsService.isTablet(),
        mobile: globalUtilsService.isMobile()
      }"
    >
      <h1><span class="real"><span class="m">Faça uma</span> Simulação!</span></h1>
      <h2>
        Preencha os dados e
        <span class="blck">entraremos em contato com você!</span>
      </h2>
    </div>
  `,
  styles: [
    `
      .contact-info-wrap h1 {
        font-size: 0.9rem;
        font-weight: 600;
        line-height: 135%;
        width: 90%;
        margin-bottom: 0.35rem;
        margin-top: 1rem;
      }

      .contact-info-wrap h1 .real {
        color: #13a538;
      }

      .contact-info-wrap h2 {
        font-size: 0.44rem;
        color: #888888;
        font-weight: 400;
        margin-bottom: 0.6rem;
        line-height: 160%;
      }

      .contact-info-wrap h2 .blck {
        color: black;
        font-weight: 600;
        /* font-size: 0.44rem; */
      }

      .contact-info-wrap.tablet h1 {
        font-size: 1.5rem;
        width: 10.5rem;
      }

      .contact-info-wrap.tablet h2 {
        font-size: 0.78rem;
        width: 8.6rem;
        margin-top: 0.55rem;
      }

      .contact-info-wrap.tablet h2 .blck {
        color: black;
        display: block;
        /* font-size: 0.78rem; */
      }

      .contact-info-wrap.mobile h1 {
        font-size: 0.75rem;
        width: 8.7rem;
        line-height: 130%;
        margin: 0;
        padding: 0;
        margin-bottom: 1.2rem;
      }

      .contact-info-wrap h1 .real .m{
        color: black;
      }

      .contact-info-wrap.mobile h2 {
        display: none;
        font-size: 0.65rem;
        width: 9rem;
        margin-top: 0.38rem;
        margin-bottom: 1.2rem;
      }

      .contact-info-wrap.mobile h2 .blck {
        color: black;
        display: inline;
        /* font-size: 0.65rem; */
      }
    `,
  ],
})
export class ContactInfoComponent {
  constructor(public globalUtilsService: GlobalUtilsService) {}
}
